<div class="copy-badge">
  <div class="copy-text">{{ id }}</div>
  <app-copy-icon
    class="clickable"
    width="16px"
    height="16px"
    color="#475467"
    (click)="copy()"
  />
</div>
